import { IAxiosError } from '@/@types/AxiosError';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { useToast } from '@/common/hooks/useToast';
import { queryClient } from '@/config/queryClient';

import { postCompliance } from '../services/postCompliance';
import { finishRequestApproval } from '../services/postFinishRequestApproval';

export function useFinishRequestApproval(userLogged = false) {
  const { t } = useTranslation('invoicing/requestApprovalReview');
  const { toast } = useToast();

  const {
    mutateAsync: mutateFinishRequestApproval,
    isLoading: isLoadingFinishRequestApproval,
  } = useMutation({
    mutationFn: finishRequestApproval,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['findOneBatch'],
        exact: false,
      });
    },
    onError: (errorRequest: IAxiosError) => {
      toast.error(
        t('errorOnFinishRequestApproval'),
        errorRequest?.response?.data?.friendlyMessage,
        {
          toastId: 'finish-request-approval',
        },
      );
    },
  });

  const {
    mutateAsync: mutatePostCompliance,
    isLoading: isLoadingPostCompliance,
  } = useMutation({
    mutationFn: postCompliance,
    onSuccess: () => {
      queryClient.invalidateQueries(['paginateBatchDebitNote'], {
        exact: false,
      });
    },
    onError: (errorRequest: IAxiosError) => {
      toast.error(
        t('errorOnFinishRequestApproval'),
        errorRequest?.response?.data?.friendlyMessage,
        {
          toastId: 'compliance-review',
        },
      );
    },
  });

  return {
    finishRequestApproval: userLogged
      ? mutatePostCompliance
      : mutateFinishRequestApproval,
    isFinishingRequestApproval: userLogged
      ? isLoadingPostCompliance
      : isLoadingFinishRequestApproval,
  };
}
